import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=ecea1ffa&scoped=true&"
import script from "./MessageDialog.vue?vue&type=script&lang=js&"
export * from "./MessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&id=ecea1ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecea1ffa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText})
